import { getSessionStorageItem, removeSessionStorageItem, setSessionStorageItem } from './storage'

export const vitePreloadReloadedKey = 'vite-preload-reloaded'

export const initLazyReloadHandler = (): void => {
  window.addEventListener('vite:preloadError', () => {
    const hasReloaded = getSessionStorageItem(vitePreloadReloadedKey)
    if (!hasReloaded) {
      setSessionStorageItem(vitePreloadReloadedKey, 'true')
      setIsReloading()
      window.location.reload()
    }
  })

  setTimeout(() => {
    removeSessionStorageItem(vitePreloadReloadedKey)
  }, 60_000)
}

export const reloadState = {
  isReloading: false,
}

export const setIsReloading = (): void => {
  reloadState.isReloading = true
}
